import * as pdfjs from "pdfjs-dist";
import { createCanvas, createImage } from "./createThumbImage";
export const countPdfPages = async (src)=>{
    pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.min.mjs");
    let doc = await pdfjs.getDocument(src).promise;
    return doc.numPages;
};
async function readPdf(src, config) {
    pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/".concat(pdfjs.version, "/pdf.worker.min.mjs");
    let doc = await pdfjs.getDocument(src).promise;
    var pages = [];
    ;
    if (!config.pages) {
        while(pages.length < doc.numPages)pages.push(pages.length + 1);
    } else if (typeof config.pages === "string") {
        const [startPageNum, endPageNum] = config.pages.split("-").map((page)=>parseInt(page));
        pages = Array.from({
            length: endPageNum - startPageNum + 1
        }, (_, i)=>i + startPageNum);
    // console.log('pages', pages)
    }
    const images = await Promise.all(pages.map(function(num) {
        return doc.getPage(num).then((page)=>{
            return createCanvas(page, config).then((canvas)=>{
                return createImage(canvas, config.filename, num);
            });
        });
    // .catch((err) => {
    // 	return [false, err]
    // })
    }));
    return {
        total: doc.numPages,
        images
    };
}
export { readPdf };
